import React, { useEffect } from "react";
import { useSelector, shallowEqual,useDispatch } from "react-redux";

import {fetchSearchResultData} from "../actions/action";
import ListingComponent from "../../../components/ListingComponent";
import FileGroup from "../../WorkkardDetail/MiddlePanelContainer/Files/fileGroup";
import * as _ from 'lodash';
import EmptyScreen from '../../../Emptyscreen';
import LoaderComponent from '../../../components/Loader';

const Files =(props)=> {
    const { globalSearch } = useSelector(state => ({
        globalSearch: state.header.globalSearch
    }), shallowEqual);

    const dispatch=useDispatch();

    const dataPayload = {
        skip: 0,
        take: 100,
        isSearch: true,
        sortDir: 'ASC',
        sortBy: 1,
        rows: 100,
        displayCount: 100,
        status: 'files',
        _: new Date()
    }

    useEffect(() => {
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;
        dispatch(fetchSearchResultData(payload));
    }, []);

    const renderListing=(files)=>{
        if (files && files.length > 0) {
            const fileIds = files.map(item=>{
                const date = item.UploadedDateString.split(' ');
                return {id:item.Id, date:date[0], time:date[1], data: item}
            });
            const groupFileIds = _.groupBy(fileIds, 'date');

            const prop = {
              data:Object.keys(groupFileIds).map(key=>({key,data:groupFileIds[key]})),
              cellTemplate: FileGroup,
              onScrollHandler: onScrollHandler,
              onItemClick: false,
              onCellClick:()=>{return false},
              type:"div",
              selectedId: '',
              classname:'scrollArea',
            }

            return (
              <ListingComponent {...prop}/>
            );
        }
        return <EmptyScreen name="Emptyfiles" />;
    }

    const onScrollHandler=()=>{
        const { skip, take,Total} = globalSearch.files;
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;
        payload.take = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.skip = (skip === 0 && take > 20 ) ? take : parseInt(skip)+parseInt(take);
        payload.rows = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.isUpdate = true;
        if(skip+take < Total){
            dispatch(fetchSearchResultData(payload));
        }
    }

    return (
        <div className={`filesMainContainer detailMainContainer ${globalSearch.files.Data.length ==0 ? `noDataFound`:''}`}>
            {
                globalSearch.isLoading && !props.showResult && <LoaderComponent/>
            }
            {
                globalSearch.files.status != null &&
                (
                    globalSearch.files.status != 200 ?
                    <EmptyScreen name="Errorscreen" onRefreshClick={()=>dispatch(fetchSearchResultData(Object.assign({},dataPayload,{key:props.searchString})))}/>
                    :
                    globalSearch.activeTab==3 && renderListing(globalSearch.files.Data)
                )
            }
        </div>
    )
}

export default Files;
